class ProductDisclaimer extends HTMLElement {
  connectedCallback() {
    const primary = this.querySelector('[data-disclaimer-primary]');
    const alternate = this.querySelector('[data-disclaimer-alternate]');

    const reveal = () => {
      this.style.display = '';
      this.removeAttribute('data-location-pending');
    };

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      if (primary) primary.style.display = '';
      reveal();
      return;
    }

    const locations = (this.dataset.locations || '')
      .split(',')
      .map(s => s.trim().toLowerCase().replace(/\s+/g, '-'))
      .filter(Boolean);
    const fallback = this.dataset.fallback || 'hide';
    const emirate = (localStorage.getItem('selectedEmirate') || '').toLowerCase();
    const matched = emirate && locations.includes(emirate);

    this.dataset.pdResolved = JSON.stringify({ emirate, locations, matched, fallback });

    if (matched && primary) {
      primary.style.display = '';
      reveal();
    } else if (!matched && fallback === 'alternate' && alternate) {
      alternate.style.display = '';
      reveal();
    } else {
      this.style.display = 'none';
    }
  }
}

if (!customElements.get('product-disclaimer')) {
  customElements.define('product-disclaimer', ProductDisclaimer);
}
